import axios from "axios";
import { getBearerToken } from "./getBearerToken";
import { BACKEND_URL, BASE_URL } from "@/constants/constants";

export const axiosInstance = axios.create({
  headers: {
    common: {
      "Access-Control-Allow-Origin": BASE_URL,
      "Content-Type": "application/json",
      "Cache-Control": "no-store, no-cache, must-revalidate, max-age=0",
    },
  },
  baseURL: `${BACKEND_URL}`,
});

export const axiosInstanceNoAuth = axios.create({
  headers: {
    common: {
      "Access-Control-Allow-Origin": BASE_URL,
      "Content-Type": "application/json",
      "Cache-Control": "no-store, no-cache, must-revalidate, max-age=0",
    },
  },
  baseURL: `${BACKEND_URL}`,
});


axiosInstance.interceptors.request.use(
  async (config) => {
    if (config.url && config.baseURL === BACKEND_URL) {
      config.headers["Authorization"] = await getBearerToken();
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);
